import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

function TrackDetail({ order }) {
  const navigate = useNavigate();

  if (!order) {
    return (
      <Typography className="responsive_fontsize16" sx={{ textAlign: "center", mt: "1rem",pb:2 }}>
        Please enter a valid Tracking ID to view order details.
      </Typography>
    );
  }

  const customerDetail = JSON.parse(order.customer_detail);

  const handleBack = () => {
    // Navigate back to TrackLandingPage and pass the order data
    navigate("/track", { state: { order } });
  };

  return (
    <Box sx={{ mt: "1.37rem" }}>
      <Box>
        <Typography
          sx={{
            fontSize: "1.25rem",
            fontWeight: "700",
            fontFamily: "Roboto Serif",
          }}
        >
          Order Detail
        </Typography>
        <Box sx={{ mt: "0.3rem" }}>
          <Typography sx={{ fontSize: "1rem", fontWeight: "600" }}>
            Order ID:{" "}
            <Typography component="span" >
              {order.order_id}
            </Typography>
          </Typography>
        </Box>
        <Box sx={{ mt: "0.3rem" }}>
          <Typography sx={{ fontSize: "1rem", fontWeight: "600" }}>
            Name:{" "}
            <Typography component="span" >
              {customerDetail.name}
            </Typography>
          </Typography>
        </Box>
        <Box sx={{ mt: "0.3rem" }}>
          <Typography sx={{ fontSize: "1rem", fontWeight: "600" }}>
            Address:{" "}
            <Typography component="span" >
              {customerDetail.address}
            </Typography>
          </Typography>
        </Box>
        <Box sx={{ mt: "0.3rem" }}>
          <Typography sx={{ fontSize: "1rem", fontWeight: "600" }}>
            Status:{ }
            <Typography component="span" >
              {order.track_status}
            </Typography>
          </Typography>
        </Box>
        <Box sx={{ mt: "0.3rem" }}>
          <Typography sx={{ fontSize: "1rem", fontWeight: "600" }}>
            Items:{" "}
            <Typography component="span" >
              {order.order_items}
            </Typography>
          </Typography>
        </Box>
        <Box sx={{ mt: "0.3rem" }}>
          <Typography sx={{ fontSize: "1rem", fontWeight: "600" }}>
            Total Price:{" "}
            <Typography component="span" >
              Rs.{order.total_price}
            </Typography>
          </Typography>
        </Box>
      </Box>
      <Box sx={{ display: "flex", justifyContent: "center", mt: "1rem" }}>
        <Button
          onClick={handleBack}
          className="responsive_fontsize16"
          variant="contained"
          sx={{
            width: "50%",
            textTransform: "capitalize",
            backgroundColor: "#000",
            color: "#fff",
            borderRadius: "1.25rem",
          }}
        >
          More Detail
        </Button>
      </Box>
    </Box>
  );
}

export default TrackDetail;
